import React, { FunctionComponent } from "react";
import {
  FormControlLabel,
  Switch,
  withStyles,
  Theme,
  createStyles,
  SwitchProps,
  SwitchClassKey,
  FormControlLabelProps
} from "@material-ui/core";
import { orange } from "@material-ui/core/colors";
import makeStyles from "@material-ui/core/styles/makeStyles";
import grey from "@material-ui/core/colors/grey";

interface ISwitchControl {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string | JSX.Element;
  disabled?: boolean;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  classes?: FormControlLabelProps['classes'];
}

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}
interface Props extends SwitchProps {
  classes: Styles;
}

const SWITCH_HEIGHT = 20;
const IOSSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: SWITCH_HEIGHT+theme.spacing(2)+2,
      height: SWITCH_HEIGHT,
      padding: 0,
      margin: theme.spacing(1),
      overflow: "visible"
    },
    switchBase: {
      padding: 1,
        left:1,
      "&$checked": {
        transform: `translateX(${theme.spacing(2)}px)`,
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: orange[300],
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: orange[300],
        border: "6px solid #fff"
      },
      "&$disabled":{
        color: theme.palette.grey[50],
          "& + $track":{
              backgroundColor: grey[50],
              opacity:1
          }
      }
    },
    thumb: {
      width: SWITCH_HEIGHT-2,
      height: SWITCH_HEIGHT-2
    },
    track: {
      borderRadius: SWITCH_HEIGHT / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
      disabled:{},
      focusVisible:{}
  })
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
          disabled: classes.disabled
      }}
      {...props}
    />
  );
});

const useStyles = makeStyles(theme => ({
    labelPlacementStart: {
        justifyContent: 'space-between',
        width: '100%',
        margin: 0
    }
}));

const SwitchControl: FunctionComponent<ISwitchControl> = ({
  checked, onChange, label, disabled,labelPlacement, classes 
}) => {
    const styles = useStyles();

    return (
        <FormControlLabel
            classes={{labelPlacementStart:styles.labelPlacementStart, ...(classes || {})}}
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
            control={<IOSSwitch checked={checked} onChange={e => onChange(e.target.checked)}/>}
        />
    );
};

export default SwitchControl;
